import React, { Component } from 'react';

import Header from './Header';
import Footer from './Footer';
import Routes from './Routes';

import { mainNav } from '../../services/a1';

class index extends Component {
  componentDidMount() {
    mainNav();
  }

  render() {
    return (
      <>
        <Header />
        <main id="a1now-main" className="a1now-main">
          <Routes />
          <Footer />
        </main>
      </>
    );
  }
}

export default index;
